import styles from './styles.module.scss';

import React from 'react';
import classNames from 'classnames';
import {CDN_PAGE_RESOURCE_URL, SIZES} from 'configs';

import {Image} from 'components/Images';
import urlJoin from 'url-join';

const IAF_LOGOS = {
  xs: urlJoin(CDN_PAGE_RESOURCE_URL, 'public/iaf-logo-xsmall.webp'),
  sm: urlJoin(CDN_PAGE_RESOURCE_URL, 'public/iaf-logo-small.webp'),
  md: urlJoin(CDN_PAGE_RESOURCE_URL, 'public/iaf-logo-medium.webp'),
  lg: urlJoin(CDN_PAGE_RESOURCE_URL, 'public/iaf-logo-large.webp'),
  xl: urlJoin(CDN_PAGE_RESOURCE_URL, 'public/iaf-logo-xlarge.webp'),
};

const Component = ({size, ...rest}) => {
  return (
    <Image
      className={classNames(styles['image-logo'], {
        [styles[`image-logo--${size}`]]: size,
      })}
      src={IAF_LOGOS[size]}
      alt="IAF Logo"
      {...rest}
    />
  );
};

Component.defaultProps = {
  size: SIZES.md,
};

export default Component;
